import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../services/api";
import { useTranslation } from "../i18n";
import "./Login.css";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [expired, setExpired] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError(t("auth.passwordTooShort"));
      return;
    }
    if (password !== confirmPassword) {
      setError(t("auth.passwordsNoMatch"));
      return;
    }

    setLoading(true);
    try {
      await api.resetPassword(token, password);
      setSuccess(true);
    } catch (err) {
      if (err.status === 400) {
        setExpired(true);
      } else {
        setError(t("auth.somethingWrong"));
      }
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-bg">
          <div className="login-gradient" />
        </div>
        <div className="login-container" style={{ justifyContent: "center" }}>
          <div className="login-card" style={{ textAlign: "center" }}>
            <div className="login-header">
              <Link to="/" className="login-brand">
                <img src="/logos/mark-black-background.jpg" alt="ViewsDay" className="login-logo" />
              </Link>
              <h1 className="login-title" style={{ color: "var(--danger)" }}>
                {t("auth.invalidResetLink")}
              </h1>
              <div style={{ marginTop: 24 }}>
                <Link to="/login" className="btn-primary" style={{ textDecoration: "none" }}>
                  {t("auth.goToLogin")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (expired) {
    return (
      <div className="login-page">
        <div className="login-bg">
          <div className="login-gradient" />
        </div>
        <div className="login-container" style={{ justifyContent: "center" }}>
          <div className="login-card" style={{ textAlign: "center" }}>
            <div className="login-header">
              <Link to="/" className="login-brand">
                <img src="/logos/mark-black-background.jpg" alt="ViewsDay" className="login-logo" />
              </Link>
              <h1 className="login-title" style={{ color: "var(--danger)" }}>
                {t("auth.resetExpired")}
              </h1>
              <div style={{ marginTop: 24 }}>
                <Link to="/forgot-password" className="btn-primary" style={{ textDecoration: "none" }}>
                  {t("auth.requestNewReset")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="login-page">
        <div className="login-bg">
          <div className="login-gradient" />
        </div>
        <div className="login-container" style={{ justifyContent: "center" }}>
          <div className="login-card" style={{ textAlign: "center" }}>
            <div className="login-header">
              <Link to="/" className="login-brand">
                <img src="/logos/mark-black-background.jpg" alt="ViewsDay" className="login-logo" />
              </Link>
              <div style={{ fontSize: 48, marginBottom: 16 }}>&#10003;</div>
              <h1 className="login-title" style={{ color: "var(--success)" }}>
                {t("auth.passwordResetSuccess")}
              </h1>
              <div style={{ marginTop: 24 }}>
                <Link to="/login" className="btn-primary" style={{ textDecoration: "none" }}>
                  {t("auth.goToLogin")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="login-gradient" />
      </div>

      <div className="login-container" style={{ justifyContent: "center" }}>
        <div className="login-card">
          <div className="login-header">
            <Link to="/" className="login-brand">
              <img src="/logos/mark-black-background.jpg" alt="ViewsDay" className="login-logo" />
            </Link>
            <h1 className="login-title">{t("auth.resetPassword")}</h1>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="login-error">{error}</div>}

            <div className="form-group">
              <label className="form-label">{t("auth.newPassword")}</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="form-input"
                required
                minLength={8}
              />
            </div>

            <div className="form-group">
              <label className="form-label">{t("auth.confirmPassword")}</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                className="form-input"
                required
                minLength={8}
              />
            </div>

            <button type="submit" className="btn-primary btn-full" disabled={loading}>
              {loading ? <span className="btn-spinner" /> : t("auth.resetPassword")}
            </button>

            <div className="login-switch">
              <Link to="/login" className="link-btn">{t("auth.backToLogin")}</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
